import Typograf from 'typograf';
import type rulesJSON from 'typograf/dist/typograf.titles.json';

// add string type to not break enableByMask method
type TypografRule = keyof typeof rulesJSON | string;

const rules: TypografRule[] = ['ru/money/currency', 'common/nbsp/afterNumber'];

const instance = new Typograf({ locale: ['ru'], enableRule: rules });

export const applyTypograf = (text: string, disableRules: TypografRule[] = []): string => {
    if (disableRules.length > 0) {
        disableRules.forEach(instance.disableRule);
    }
    return instance.execute(text);
};
